import { ItemList } from '../orm'

class FaxCostStructureVariantList extends ItemList {
    getEntityKey() {
        return "fax_cost_structure_variant"
    }
}

export const faxCostStructureVariantList = new FaxCostStructureVariantList("fax_cost_structure_variant__default")
